import { AnalyticsEvent } from '../../../analytics/events/analytics.event'

export class VideoPlayEvent extends AnalyticsEvent {

  constructor (eventLabel: string = '') {
    super('videoPlay', 'Video', 'Play', eventLabel)
  }
}

export class VideoPauseEvent extends AnalyticsEvent {

  videoDuration: number

  constructor (eventLabel: string = '', videoDuration: number = 0) {
    super('videoPause', 'Video', 'Pause', eventLabel)
    this.videoDuration = videoDuration
  }
}

export class VideoEndedEvent extends AnalyticsEvent {

  constructor (eventLabel: string = '') {
    super('videoEnded', 'Video', 'Ended', eventLabel)
  }
}

export class VideoOpenEvent extends AnalyticsEvent {

  constructor (eventLabel: string = '') {
    super('click', 'Video', 'Open', eventLabel)
  }
}

export class VideoLengthEvent extends AnalyticsEvent {

  constructor (eventLabel: string = '',) {
    super('videoLength', 'Video', 'watch duration', eventLabel)
  }
}
